import { render } from "./Tal_smallCommonConfirmPop.vue?vue&type=template&id=097b0f44"
import script from "./Tal_smallCommonConfirmPop.vue?vue&type=script&lang=js"
export * from "./Tal_smallCommonConfirmPop.vue?vue&type=script&lang=js"

import "./Tal_smallCommonConfirmPop.vue?vue&type=style&index=0&id=097b0f44&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__